import type { ShellStrokeIconProps } from '@zrsystem/ui';
import type { ComponentType } from 'react';

export type ShellNavTaxonomyEntity =
  | 'categories'
  | 'brands'
  | 'product-types'
  | 'service-types'
  | 'manufacturers'
  | 'measurement-units';

export interface ShellNavLink {
  kind: 'link';
  id: string;
  label: string;
  icon: ComponentType<ShellStrokeIconProps>;
  path?: string;
  matchPrefix?: string;
  enabled?: boolean;
}

export interface ShellNavChildRoute {
  kind: 'route';
  id: string;
  label: string;
  icon: ComponentType<ShellStrokeIconProps>;
  path: string;
  matchPrefix: string;
  /** When false, child is visible but non-navigable (`em breve`). Default true. */
  enabled?: boolean;
}

export interface ShellNavChildQuickPanel {
  kind: 'quickPanel';
  id: string;
  label: string;
  icon: ComponentType<ShellStrokeIconProps>;
  panelKey: 'catalog-taxonomy-list';
  entity: ShellNavTaxonomyEntity;
  title: string;
}

export interface ShellNavChildFormDrawer {
  kind: 'formDrawer';
  id: string;
  label: string;
  icon: ComponentType<ShellStrokeIconProps>;
  drawerKey: string;
  title?: string;
}

export type ShellNavChildLink =
  | ShellNavChildRoute
  | ShellNavChildQuickPanel
  | ShellNavChildFormDrawer;

export interface ShellNavGroup {
  kind: 'group';
  id: string;
  label: string;
  icon: ComponentType<ShellStrokeIconProps>;
  matchPrefix: string;
  defaultPath: string;
  children: readonly ShellNavChildLink[];
}

export type ShellNavEntry = ShellNavLink | ShellNavGroup;

export function isShellNavGroup(entry: ShellNavEntry): entry is ShellNavGroup {
  return entry.kind === 'group';
}

export function isShellNavChildRoute(child: ShellNavChildLink): child is ShellNavChildRoute {
  return child.kind === 'route';
}

export function isShellNavChildQuickPanel(
  child: ShellNavChildLink,
): child is ShellNavChildQuickPanel {
  return child.kind === 'quickPanel';
}

export function isShellNavChildFormDrawer(
  child: ShellNavChildLink,
): child is ShellNavChildFormDrawer {
  return child.kind === 'formDrawer';
}

export const SHELL_SIDEBAR_WIDTH_COLLAPSED = '56px';
export const SHELL_SIDEBAR_WIDTH_EXPANDED = '220px';
export const SHELL_SIDEBAR_EXPANDED_STORAGE_KEY = 'main-nav-expanded';
